import { get, postFormData, postJson } from '@/utils/request'

// 获取新闻咨询
export const getBizNewArticlesList = (data) => get('/articles/bizNewArticles/list', data)

// 添加留言
export const addLeaveMessage = (data) => postJson('/leaving/bizLeavingMessage/add', data)